module.exports = __webpack_public_path__ + "img/category-skill-game-hover.c833ff86.png";